// extracted by mini-css-extract-plugin
export default {"productGrid":"OZ-z","centerLink":"PZ-z","productSection":"QZ-z","item":"RZ-z","ctaButton":"SZ-z"};